import './PageStoryImage.css';

// Supporting photography inside the page's existing content width.
export default function PageStoryImage({ src, alt, position = 'center', testId }) {
  return <figure className="page-story-image" data-testid={testId}>
    <img src={src} alt={alt} loading="lazy" decoding="async" width="1448" height="1086" style={{ objectPosition: position }} />
  </figure>;
}
